import React, { Component } from 'react'
import { BreakItem, UserList } from '../styles/dialpadstyle'
import styled from 'styled-components'

const ExtendedUserList = styled(UserList)`
  height: 360px;
  padding: 0;

  @media (max-width: 768px) {
    height: 100%;
    width: 100%;
  }
`

const BreakMain = styled.div`
  @media (max-width: 768px) {
    width: 100%;
  }
`
export class CallBreakTheme extends Component {

    renderBreakName( name, el, onSelect) {
        return (
            <BreakItem onClick={()=>{
              onSelect(el);
            }}>
                {(name)}
            </BreakItem>
        )
    }
    render() {
      const { breakList, onSelect } = this.props
        return (
            <BreakMain>
              <ExtendedUserList>
                { 
                  breakList.map(( el )=>{
                    return (
                      this.renderBreakName(
                        el.name,
                        el,
                        onSelect
                      )
                    )
                  })
                }
              </ExtendedUserList>
            </BreakMain>
        )
    }
}

export default CallBreakTheme


// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/CallBreakTheme.js